import { render, staticRenderFns } from "./SimpleStockValue.vue?vue&type=template&id=3c084322&"
import script from "./SimpleStockValue.vue?vue&type=script&lang=js&"
export * from "./SimpleStockValue.vue?vue&type=script&lang=js&"
import style0 from "./SimpleStockValue.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports